import { getDefaultImageLayerData } from '@meitu/saas-editor-core/es/layers/image-layer/constants/default-image-data';
import { createTextLayer } from '@meitu/saas-editor-core/es/layers/text-layer';
import { DEFAULT_LINE_HEIGHT_FACTOR } from '@meitu/saas-editor-core/es/layers/text-layer/constants';
import { checkIsDarkColor } from '@meitu/saas-editor-core/es/utils/color-kit';
import { getImgLayerProps } from '@meitu/saas-editor-core/es/utils/layer-kit';
import { SizeUnitType } from '@meitu/saas-editor-core/es/utils/unit-kit';
import { uploadBase64ToObs } from '@meitu/saas-editor-core/es/utils/upload-kit';
import { CanvasType, ILayerProps, PosterType } from '@meitu/saas-editor-core/es/version-types';
import { DownloadImgType } from '@meitu/saas-editor-ui/es/utils/stage';
import useOpenPlugins from '@/editor/collapse/views/more-collapse/hooks/use-open-plugins';
import { getLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { useStoreActions } from '@/store';
import { initMenu, isInitAiText } from './init-menu';

export const useInitEmptyTemplate = () => {
    const { $t } = getLocaleStore();
    const setPreview = useStoreActions((actions) => actions.templateModel.setPreview);
    const setPosterType = useStoreActions((actions) => actions.recordModel.setPosterType);
    const { openPlugin } = useOpenPlugins();
    const setCurrentType = useStoreActions((actions) => actions.collapseModel.setCurrentType);

    return async function (
        width: number,
        height: number,
        unit: SizeUnitType,
        imgUrl?: string,
        // createInfo 参考 https://cf.meitu.com/confluence/pages/viewpage.action?pageId=328480736
        createInfo?: Record<string, any>,
        stageInfo?: { posterType: PosterType; canvasType: CanvasType },
    ) {
        editor.stage.setUnit(unit);
        setPosterType(stageInfo?.posterType ?? PosterType.EmptyPoster);

        const finalLayers: ILayerProps[] = [];

        const backgroundColor = createInfo?.bg?.backgroundColor || '#ffffffff';
        const bgLayer = editor.backgroundLayer.create({
            width,
            height,
            backgroundColor,
        });

        finalLayers.push(bgLayer);

        const stageSize = { width, height };

        if (imgUrl) {
            const imageLayerData = getDefaultImageLayerData(
                imgUrl,
                createInfo?.mainImage?.width || width,
                createInfo?.mainImage?.height || height,
                createInfo?.mainImage?.left || 0,
                createInfo?.mainImage?.top || 0,
                '',
                createInfo?.mainImage?.naturalWidth || width,
                createInfo?.mainImage?.naturalHeight || height,
                false,
            );
            // 获取图片图层数据
            const layer = getImgLayerProps(imageLayerData);
            finalLayers.push(layer);
        } else if (stageInfo?.posterType === PosterType.NormalPPT) {
            // 正常PPT
        } else {
            // const text = isInitAiText() ? { text: $t((v) => v.hooks.editOnLeft) } : {};
            // const color = checkIsDarkColor(backgroundColor) ? '#ffffffff' : '#000000ff';
            // const textLayer = await createTextLayer(stageSize, { ...text, color });
            // finalLayers.push(textLayer);
        }

        // 插入图层
        editor.stage.insertWithoutHistory([finalLayers], [{ width, height, threshold: 0 }]);
        if (imgUrl && finalLayers[1]) {
            editor.active.set(finalLayers[1].id);
        }
        const { cover } = await editor.download.drawStages(1, DownloadImgType.png);
        const previewCanvas = await editor.download.scaleContain(cover, 400, 400 / (width / height));
        const { url } = await uploadBase64ToObs(previewCanvas.toDataURL('image/png'));
        setPreview(url);

        setCurrentType(initMenu(stageInfo?.canvasType ?? CanvasType.NORMAL, undefined, openPlugin));
    };
};
